import { html, LitElement } from 'lit'
import { customElement } from 'lit/decorators.js'

import { injectLegacyLightDomStyles } from '../common/light-dom-styles.js'
import style from './FieldSeparator.css'

/**
 * Field Separator draws a thin divider between sections inside a
 * [Field Group](/components/field-group/).
 *
 * @status draft
 * @category form
 * @lightDom true
 *
 * @part separator - The dividing line.
 */
@customElement('nord-field-separator')
export default class FieldSeparator extends LitElement {
  connectedCallback() {
    super.connectedCallback()
    injectLegacyLightDomStyles(this, style)

    // A purely visual divider; hide it from assistive technology.
    if (!this.hasAttribute('aria-hidden')) {
      this.setAttribute('aria-hidden', 'true')
    }
  }

  // Renders its own divider markup; there are no user children to preserve.
  protected createRenderRoot() {
    return this
  }

  render() {
    return html`<hr part="separator" />`
  }
}

declare global {
  interface HTMLElementTagNameMap {
    'nord-field-separator': FieldSeparator
  }
}
